const colSpans = [
    'col-span-1',
    'col-span-2',
    'col-span-3',
    'col-span-4',
    'col-span-5',
    'col-span-6',
    'col-span-7',
    'col-span-8',
    'col-span-9',
    'col-span-10',
    'col-span-11',
    'col-span-12',
    'md:col-span-1',
    'md:col-span-2',
    'md:col-span-3',
    'md:col-span-4',
    'md:col-span-5',
    'md:col-span-6',
    'md:col-span-7',
    'md:col-span-8',
    'lg:col-span-1',
    'lg:col-span-2',
    'lg:col-span-3',
    'lg:col-span-4',
    'lg:col-span-5',
    'lg:col-span-6',
    'lg:col-span-7',
    'lg:col-span-8',
    'lg:col-span-9',
    'lg:col-span-10',
    'lg:col-span-11',
    'lg:col-span-12',
];

const gridCols = ['lg:grid-cols-3', 'grid-cols-3'];

const widths = [
    'max-w-xs',
    'max-w-sm',
    'max-w-md',
    'max-w-lg',
    'max-w-xl',
    'max-w-2xl',
    'max-w-3xl',
    'max-w-4xl',
    'max-w-5xl',
    'max-w-6xl',
    'max-w-7xl',
    'max-w-full',
    'md:w-48',
    'md:w-52',
    'md:w-1/3',
    'lg:w-1/5',
];

const backgroundColors = [
    'bg-transparent',
    'bg-current',
    'bg-black',
    'bg-blue-dark',
    'bg-blue',
    'bg-blue-light',
    'bg-blue-lightest',
    'bg-blue-baby',
    'bg-blue-sky',
    'bg-blue-disabled',
    'bg-blue-link',
    'bg-blue-lightsky',
    'bg-gray-dark',
    'bg-gray',
    'bg-gray-light',
    'bg-gray-lightest',
    'bg-gray-accessible',
    'bg-gray-disabled',
    'bg-gray-outline',
    'bg-gray-hr',
    'bg-pink',
    'bg-orange',
    'bg-green-dark',
    'bg-green',
    'bg-green-light',
    'bg-green-lightest',
    'bg-green-disabled',
    'bg-green-underline',
    'bg-red',
    'bg-red-lighter',
    'bg-red-lightest',
    'bg-white',
    'bg-yellow-lightest',
    'bg-purple',
    'bg-purple-light',
    'bg-surface-primary-darker',
    'bg-surface-primary',
    'bg-surface-dark',
    'bg-surface-light',
    'bg-surface-300',
    'bg-surface-200',
    'bg-surface-100',
    'bg-surface-50',
];

const fontSizes = ['text-base', 'text-lg', 'text-xl'];

const layoutConfgs = ['md:flex-row-reverse'];

module.exports = [
    ...colSpans,
    ...gridCols,
    ...widths,
    ...backgroundColors,
    ...layoutConfgs,
    ...fontSizes,
];
